export default {
    achievements(state) {
        return state.achievements;
    },
    wonCount(state){
        return state.achievements.filter(item => item.won === 1).length
    }
};
